import { HTMLAttributes, useRef } from 'react';
import { Swiper} from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import 'swiper/css';

import { IconButton } from '@/shared/ui/Button/IconButton';
import Arrow from '@/assets/icons/white_arrow.svg?react';
import { cn } from '@/shared/lib/utils';


interface IHorizontalSliderProps extends HTMLAttributes<HTMLDivElement> {
    spaceBetween?: number,
    className?: string,
    buttonClassName?: string
}

export function HorizontalSlider({ spaceBetween, className, children, buttonClassName}: IHorizontalSliderProps) {

    const swiperRef = useRef<SwiperType | null>(null);

    const handleSwiperNext = () => {
        if (swiperRef.current) swiperRef.current.slideNext()
    }

    const handleSwiperPrev = () => {
        if (swiperRef.current) swiperRef.current.slidePrev()
    }

    return (
        <div className={cn('w-full h-fit rounded-2xl overflow-hidden relative', className)} >


            <IconButton
                className='absolute right-[10px] md:right-[20px] top-1/2 -translate-y-1/2 z-10 w-[40px] h-[40px] backdrop-blur-[20px] border-2 border-white bg-[#FFFFFF33]' 
                icon={<Arrow className='h-[18px] w-[9px] stroke-white'/>}
                onClick={handleSwiperNext}
            />
            <IconButton
                className='absolute left-[10px] md:left-[20px] top-1/2 -translate-y-1/2 z-10  w-[40px] h-[40px] backdrop-blur-[20px] border-2 border-white bg-[#FFFFFF33]'
                icon={<Arrow className='h-[18px] w-[9px] rotate-180 stroke-white'/>}  
                onClick={handleSwiperPrev}
            />

            <Swiper
                direction="horizontal"
                 modules={[]}
                slidesPerView='auto'
                spaceBetween={spaceBetween}
                pagination={{ clickable: true }}
                className="mySwiper h-auto"
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {children}
            </Swiper>
        </div>
    );
}
